import {configureStore} from '@reduxjs/toolkit';
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import App from './components/app/app';
import {createAPI} from './services/api';
import {fetchGuitarsAction} from './store/api-actions';
import {rootReducer} from './store/root-reducer';
import browserHistory from './browser-history';
import {Router as BrowserRouter} from 'react-router-dom';
import {changeIsDataLoaded} from './store/action';

const api = createAPI(
  () => store.dispatch(changeIsDataLoaded(true)),
);

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: api,
      },
    }),
});

store.dispatch(fetchGuitarsAction());

ReactDOM.render(
  <React.StrictMode>
    <Provider store = {store}>
      <BrowserRouter history={browserHistory}>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'));
